import { inject, Injectable, signal } from '@angular/core';

import { AuthService } from '@auth0/auth0-angular';

import { TenantOverrideService } from '@core/services/tenant-override.service';

/** Error code of the API when the token's session was ended (Portal "Sitzungen beenden"). */
export const API_ERROR_SESSION_REVOKED = 'session_revoked';

/** True for an API error body `{ error: 'session_revoked' }`. */
export function isSessionRevokedBody(body: unknown): boolean {
  return (body as { error?: string } | null)?.error === API_ERROR_SESSION_REVOKED;
}

/**
 * The API answers 401 `session_revoked` once the session was ended elsewhere. The token itself is still
 * valid, so a re-login redirect would sign the user straight back in via the live Auth0 session: tell them
 * (SessionRevokedDialog), then log out. Shown once, however many requests fail at the same time.
 */
@Injectable({ providedIn: 'root' })
export class SessionRevokedService {
  private readonly auth0 = inject(AuthService);
  private readonly tenantOverride = inject(TenantOverrideService);

  private readonly _visible = signal(false);
  readonly visible = this._visible.asReadonly();

  /** Opens the notice; later calls while it is open (or after) are no-ops. */
  handle(): void {
    this._visible.set(true);
  }

  /** "Abmelden": the only way out of the notice. */
  confirm(): void {
    this.tenantOverride.clearSilently();
    this.auth0.logout({ logoutParams: { returnTo: window.location.origin } });
  }
}
